var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "magnifying-glass",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.599,
    height: 19,
    viewBox: "0 0 18.599 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M13.064,4.988a7.676,7.676,0,0,1,6.575,11.637l3.721,3.721-.013.013a2.113,2.113,0,0,1-1.475,3.629,2.12,2.12,0,0,1-1.523-.632l-.009.009L16.5,19.525A7.675,7.675,0,1,1,13.064,4.988ZM13.017,17.32a4.8,4.8,0,1,0-4.8-4.8,4.8,4.8,0,0,0,4.8,4.8Z",
    transform: "translate(-5.389 -4.988)",
    fill: "#6f6f6f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.5e367b22687ef9ada9e7b663d73a62f3.svg";
export { ForwardRef as ReactComponent };